import gql from 'graphql-tag';

export const GET_PROJECT_BY_ID = gql`
  query getProjectById($projectId: String) {
    finance {
      project(projectId: $projectId) {
        _id
        accountingCode
        accountingCodeSuffix
        projectCode
        name
        owner
        description
        archived
        sectors
        updatedAt
        syncedAt
        budget
        budgetUsed
        totalCost
        proposedBudget
        deductExpenses
        globallyVisible
        complete
        status
        hoursUsedPct
        totalApprovedHours
        totalBilledAmount
        actualHoursRemaining
        startDate
        earliestTaskDate
        latestTaskDate
        documents {
          _id
          filePath
          url
          fileName
        }
        client {
          _id
          shortName
          name
        }
        projectClient {
          _id
          shortName
          name
        }
        showEndClient
        endClient {
          _id
          shortName
          name
        }
        roles {
          _id
          name
        }
        quickbooks {
          jobName
        }
        integration {
          sourceId
        }
      }
    }
  }
`;

export const GET_TIMESHEETS_FOR_FINANCE = gql`
  query getTimesheetsForFinance($startDate: String, $endDate: String, $queryString: String) {
    finance {
      timesheetSnapshots(startDate: $startDate, endDate: $endDate, queryString: $queryString)
    }
    users {
      _id
      firstName
      lastName
      emails {
        address
      }
    }
  }
`;

export const GET_TIMESHEET_WEEKLY_SNAPSHOT = gql`
  query getTimesheetWeeklySnapshot($startDate: String, $endDate: String) {
    finance {
      timesheetSnapshots(startDate: $startDate, endDate: $endDate)
    }
  }
`;

export const GET_TIMESHEET_LATENESS_BY_WEEK = gql`
  query getTimesheetLatenessByWeek($startDate: String, $endDate: String) {
    finance {
      timesheetLatenessByWeek(startDate: $startDate, endDate: $endDate)
    }
  }
`;

export const GET_TIMESHEET_LATENESS_DETAILS = gql`
  query getTimesheetLatenessDetails($endDate: String!) {
    finance {
      timesheetLatenessDetails(endDate: $endDate)
    }
  }
`;

export const GET_PROJECTS = gql`
  fragment project on Project {
    _id
    accountingCode
    projectCode
    name
    description
    client: projectClient {
      shortName
    }
  }
  query getProjects {
    finance {
      allProjects {
        ...project
      }
    }
  }
`;

export const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($id: ID!, $input: UpdateUserSettingsInput!) {
    updateUserSettings(_id: $id, input: $input)
  }
`;

export const GET_MY_SETTINGS = gql`
  query GET_MY_SETTINGS {
    me {
      _id
      settings {
        timesheetDailySnapshotOverrides
      }
    }
  }
`;

export const GET_PROJECT_CLASSIFICATIONS = gql`
  query GetProjectClassifications($projectIds: [String!]!) {
    finance {
      projects(projectIds: $projectIds) {
        _id
        classification
      }
    }
  }
`;
